import { render, staticRenderFns } from "./TooltipText.vue?vue&type=template&id=e7b0de2a"
import script from "./TooltipText.vue?vue&type=script&lang=ts"
export * from "./TooltipText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports